import type { ForwardingEmailKey } from './types';

export const getForwardingEmailKey = (): ForwardingEmailKey => [
  'suppliers',
  'emailForwarding',
];
